export const tableauParameterConstants = Object.freeze({
  ORGANIZATION_PARAMETER: 'Organization Parameter',
})
